// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import React from 'react';

type Props = {
  onClick: () => void;
};

export const CreateSweepButton: React.FC<Props> = ({onClick}) => {
  return (
    <Button
      icon="sweeps-broom"
      variant="secondary"
      twWrapperStyles={{display: 'inline'}}
      onClick={onClick}>
      New sweep
    </Button>
  );
};
